<script setup>
  const {} = defineProps(['highlights', 'hide_title', 'solid', 'darken']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <Section>
    <BigTitle black>
      <slot />
    </BigTitle>
    <Foreground>
      <NewsHighlights :items="highlights" :hide_title="hide_title" :solid="solid" :darken="darken" />
    </Foreground>
    <Wrapper wide class="all-news"><Button to="/news" outline color="black">All news</Button></Wrapper>
  </Section>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  section {
    background-color: $white;
    padding: px(80) 0 px(64);

    .all-news {
      display: flex;
      justify-content: center;

      margin-top: px(32);

      @include break-min-small {
        // display: none;
        margin-top: px(32);
      }
    }

    @include break-phone {
      padding-bottom: px(64);
    }
  }
</style>
